// Shared by BillingOverdueModal (what the customer sees in the app) and the
// billing webhook (what they get emailed), so both tell the same story.
//
// Stripe's attempt_count on the failed invoice. The first failure gets grace:
// it is usually an expired card or a bank blip that Stripe's own retry fixes.
//   1st failure: nothing
//   2nd failure: notice with the retry date and a payment method link
//   3rd failure: same, plus a warning that the next failure pauses access
//   4th failure: blocked until the invoice is paid
export const NOTICE_FROM_ATTEMPT = 2;
export const WARN_FROM_ATTEMPT = 3;
export const BLOCK_AFTER_ATTEMPTS = 4;

export type BillingStage = "none" | "notice" | "warning" | "blocked";

// Once Stripe has stopped retrying (nextAttemptAt null) a failure counts one
// step further along, since nothing automatic is coming to fix it.
export const billingStageFor = (
  attemptCount: number,
  nextAttemptAt: number | null
): BillingStage => {
  const effective = attemptCount + (nextAttemptAt === null ? 1 : 0);
  if (effective >= BLOCK_AFTER_ATTEMPTS) return "blocked";
  if (effective >= WARN_FROM_ATTEMPT) return "warning";
  if (effective >= NOTICE_FROM_ATTEMPT) return "notice";
  return "none";
};
